import * as React from "react";
const StaffSchedulesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m16 14.39-4-2v-5m0 14a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
    />
  </svg>
);
export default StaffSchedulesIcon;
